import _ from "lodash";
import axios from "axios";
import axiosFileupload from "axios-fileupload";
import {
  APP_API_KEY,
  BASE_IMAGES_URL,
  INSTANCE_URL,
  itemCount,
} from "Constants";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import {
  getRequest,
  postRequest,
  deleteRequest,
  fileUploadRequest,
  patchRequest,
  uploadEncodedFile,
  deleteBulkRequest,
} from "NetworkCall";
import { randomstring } from "randomstring-js";

export var FETCH_ALL_SPEAKERS = "fetch_all_speakers";
export var FETCH_SPEAKERS = "fetch_speakers";
export var OPEN_SPEAKER_MODAL = "open_speaker_modal";
export var DELETE_SPEAKERS_SUCESS = "delete_speakers_success";
export var DELETE_SPEAKERS_ERROR = "delete_speakers_error";
export var LOAD_EDIT_SPEAKER_DATA = "load_speaker_edit_data";
export var UPDATED_SPEAKER_IMAGE = "UPDATED_SPEAKER_IMAGE";
export var IMPORT_SPEAKER_MODAL = "IMPORT_SPEAKER_MODAL";
export var INSERT_SPEAKERS = "insert_speakers";
export var UPDATE_SPEAKERS_FILES = "UPDATE_SPEAKERS_FILES";
export var SPEAKER_FILES_CHANGED = "SPEAKER_FILES_CHANGED";
export var SPEAKER_COUNTING_NUMBERS = "SPEAKER_COUNTING_NUMBERS";

export function fetchAllSpeakers(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/speaker?related=appuser_by_speakeridfk&include_count=true&filter=eventid=${session.eventid}&order=speakerid%20ASC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: FETCH_ALL_SPEAKERS,
          payload: { data: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function fetchSpeakers(session, pageCount = 0, callback) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${perPage}&offset=${offset}`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/speaker?related=appuser_by_speakeridfk&include_count=true&filter=eventid=${session.eventid}&order=speakerid%20ASC${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: FETCH_SPEAKERS,
          payload: { data: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function searchSpeakers(session, search, pageCount = 0) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${perPage}&offset=${offset}`;

  if (search.length > 1) {
    if (search.length == 2) {
      if (search[0] === "" && search[1] === "") {
        var others = search.join(" ");

        var searchQuery = `(email like %25${others}%25)OR(company like %25${others}%25)OR(position like %25${others}%25)`;
      } else {
        var others = search.join(" ");

        var searchQuery = `(firstname=${search[0]})OR(firstname like %25${others}%25)OR(lastname=${search[1]})OR(email like %25${others}%25)OR(company like %25${others}%25)OR(position like %25${others}%25)`;
      }
    } else if (search.length == 3) {
      var others = search.join(" ");
      var fname = `${search[0]} ${search[1]}`;
      var lname = `${search[2]}`;

      var searchQuery = `(firstname=${fname})OR(lastname=${lname})OR(email like %25${others}%25)OR(company like %25${others}%25)OR(position like %25${others}%25)`;
    } else if (search.length > 3) {
      var others = search.join(" ");

      var searchQuery = `(email like %25${others}%25)OR(company like %25${others}%25)OR(position like %25${others}%25)`;
    }
  } else {
    var keywords = search[0];
    if (typeof search === "string") {
      keywords = search;
    }

    var searchQuery = `(firstname like %25${keywords}%25)OR(lastname like %25${keywords}%25)OR(email like %25${keywords}%25)OR(company like %25${keywords}%25)OR(position like %25${keywords}%25)`;
  }

  // var searchQuery = `(firstname like %${search}%)OR(lastname like %${search}%)OR(email like %${search}%)OR(company like %${search}%)OR(position like %${search}%)`;

  var filter = encodeURI(`(eventid=${session.eventid})AND(${searchQuery})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/speaker?related=appuser_by_speakeridfk&include_count=true&filter=(${filter})&order=speakerid%20ASC${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: FETCH_SPEAKERS,
          payload: { data: data.resource, count: data.meta.count },
        });
      },
      (error) => {}
    );
  };
}

export function sortByName(session, sort = "az", pageCount = 0) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${perPage}&offset=${offset}`;
  var filter = encodeURI(`(eventid=${session.eventid})`);

  let orderBy = `&order=speakerid%20ASC`;
  if (sort == "az") {
    orderBy = `&order=firstname%20ASC`;
  }
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/speaker?related=appuser_by_speakeridfk&include_count=true&filter=(${filter})${orderBy}${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: FETCH_SPEAKERS,
          payload: { data: data.resource, count: data.meta.count },
        });
      },
      (error) => {}
    );
  };
}

export function deleteSpeaker(session, speakerid, callback) {
  return (dispatch) => {
    var urlDeleteSpeaker = `${INSTANCE_URL}/api/v2/eventify/_table/speaker/${speakerid}`;
    deleteRequest(
      urlDeleteSpeaker,
      session,
      dispatch,
      (data) => {
        callback({ error: 0, data: data });
        // dispatch(fetchSpeakers(session));
      },
      (error) => {
        callback({ error: 1, data: error });
      }
    );
  };
}

export function deleteAssociatedAppuser(session, id, callback) {
  var deleteUrl = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?filter=(speakeridfk=${id})`;

  return (dispatch) => {
    deleteRequest(
      deleteUrl,
      session,
      dispatch,
      (data) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function isimportant(session, speaker, value, callback) {
  let body = { featured: value };
  let data = { resource: body };
  var filter = encodeURI(
    `(eventid=${session.eventid}) AND (speakerid=${speaker.speakerid})`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/speaker?filter=(${filter})`;
  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (data) => {
        callback({ success: 1 });
        // dispatch(fetchSpeakers(session));
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function insertSpeaker(
  session,
  values,
  speaker,
  imagedata,
  filechanged,
  uploadFiles,
  callback
) {
  //debugger;
  var eventid = session.eventid;
  values = { ...values, eventid };

  return (dispatch) => {
    if (imagedata && filechanged.ischanged) {
      _uploadProfile(session, imagedata, dispatch, (profile) => {
        if (profile.success) {
          _uploadAttachedFiles(
            session,
            uploadFiles,
            dispatch,
            (attachments) => {
              values = {
                ...values,
                profileimage: profile.data.path,
                profilethumbimage: profile.data.path,
                file1: attachments[0].file,
                file2: attachments[1].file,
                file3: attachments[2].file,
                file4: attachments[3].file,
                file5: attachments[4].file,
              };
              _createUpdateSpeaker(
                session,
                values,
                speaker,
                dispatch,
                (feedback) => {
                  if (feedback.success) {
                    dispatch(
                      _updateAppuserSpeakers(
                        session,
                        values,
                        speaker,
                        feedback.speakerid,
                        callback
                      )
                    );
                  } else {
                    callback({ error: 0, data: feedback.data });
                  }
                }
              );
              // dispatch(_createUpdateSpeaker(session,values,speaker,callback));
            }
          );
        } else {
          callback({ error: 2, data: profile.data.message });
        }
      });
    } else if (imagedata && !filechanged.ischanged) {
      _uploadProfile(session, imagedata, dispatch, (profile) => {
        if (profile.success) {
          values = {
            ...values,
            profileimage: profile.data.path,
            profilethumbimage: profile.data.path,
          };
          _createUpdateSpeaker(
            session,
            values,
            speaker,
            dispatch,
            (feedback) => {
              if (feedback.success) {
                dispatch(
                  _updateAppuserSpeakers(
                    session,
                    values,
                    speaker,
                    feedback.speakerid,
                    callback
                  )
                );
              } else {
                callback({ error: 0, data: feedback.data });
              }
            }
          );
          // dispatch(_createUpdateSpeaker(session,values,speaker,callback));
        } else {
          callback({ error: 2, data: profile.data.message });
        }
      });
    } else if (!imagedata && filechanged.ischanged) {
      _uploadAttachedFiles(session, uploadFiles, dispatch, (attachments) => {
        values = {
          ...values,
          file1: attachments[0].file,
          file2: attachments[1].file,
          file3: attachments[2].file,
          file4: attachments[3].file,
          file5: attachments[4].file,
        };
        _createUpdateSpeaker(session, values, speaker, dispatch, (feedback) => {
          if (feedback.success) {
            dispatch(
              _updateAppuserSpeakers(
                session,
                values,
                speaker,
                feedback.speakerid,
                callback
              )
            );
          } else {
            callback({ error: 0, data: feedback.data });
          }
        });
        // dispatch(_createUpdateSpeaker(session,values,speaker,callback));
      });
    } else {
      values = { ...values };
      _createUpdateSpeaker(session, values, speaker, dispatch, (feedback) => {
        if (feedback.success) {
          dispatch(
            _updateAppuserSpeakers(
              session,
              values,
              speaker,
              feedback.speakerid,
              callback
            )
          );
        } else {
          callback({ error: 0, data: feedback.data });
        }
      });
      // dispatch(_createUpdateSpeaker(session,values,speaker,callback));
    }
  };
}

export function _uploadProfile(session, imagedata, dispatch, callback) {
  var eventid = session.eventid;
  imagedata = imagedata.replace(/^data:image\/[a-z]+;base64,/, "");
  var filename = `eventify/${eventid}/images/speakers/${randomstring(32)}.jpg`;
  var imageJson = {
    resource: [
      {
        name: filename,
        type: "file",
        is_base64: true,
        content: imagedata,
      },
    ],
  };

  uploadEncodedFile(
    `${BASE_IMAGES_URL}?check_exist=false`,
    session,
    imageJson,
    dispatch,
    (data) => {
      callback({ success: 1, data: data });
    },
    (error) => {
      callback({ success: 0, message: error });
    }
  );
}

export function _uploadAttachedFiles(session, uploadFiles, dispatch, callback) {
  var promiseArray = [];
  var eventid = session.eventid;
  _.map(uploadFiles, (item, index) => {
    promiseArray.push(
      new Promise((resolve, reject) => {
        var file = item.file;
        var name = item.filename;
        var n = file.search(";base64,");
        if (n > 0) {
          var content = file.split(";base64,")[1];
          var fileCustomName = name.substr(0, name.lastIndexOf("."));
          var fileType = name.split(".").pop();

          var filename = `eventify/${eventid}/files/speakers/${fileCustomName}_${randomstring(
            32
          )}.${fileType}`;
          var imageJson = {
            resource: [
              {
                name: filename,
                type: "file",
                is_base64: true,
                content: content,
              },
            ],
          };
          uploadEncodedFile(
            `${BASE_IMAGES_URL}?check_exist=false`,
            session,
            imageJson,
            dispatch,
            (data) => {
              uploadFiles[index].file = data.name;
              resolve();
            },
            (error) => {
              // callback({success:2, message:error});
            }
          );
        } else if (file == "") {
          uploadFiles[index].file = null;
          resolve();
        } else {
          uploadFiles[index].file = file;
          resolve();
        }
      })
    );
  });

  Promise.all(promiseArray).then(() => {
    callback({ ...uploadFiles });
  });
}

export function _createUpdateSpeaker(
  session,
  values,
  speaker,
  dispatch,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/speaker`;
  var speakerJson = {};
  if (speaker.speakerid) {
    delete values["appuser_by_speakeridfk"];

    speakerJson = { resource: { ...values, speakerid: speaker.speakerid } };
  } else {
    speakerJson = { resource: values };
  }

  if (speaker.speakerid) {
    patchRequest(
      url,
      speakerJson,
      session,
      dispatch,
      (data) => {
        var speakerid = data.resource[0].speakerid;
        callback({ success: 1, speakerid: speakerid });
      },
      (error) => {
        callback({ success: 0, data: error });
      }
    );
  } else {
    postRequest(
      url,
      speakerJson,
      session,
      dispatch,
      (data) => {
        var speakerid = data.resource[0].speakerid;
        callback({ success: 1, speakerid: speakerid });
      },
      (error) => {
        callback({ success: 0, data: error });
      }
    );
  }
}

function _updateAppuserSpeakers(session, values, speaker, speakerid, callback) {
  var selectedUsersStr = values.permittedusers;

  // Update with null of the speakerid, and then update with new speakerid to the selected appusers
  var filter = `((eventid=${session.eventid}) AND (speakeridfk=${speakerid}))`;
  var urlClear = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?filter=${filter}`;
  var bodyNull = { resource: [{ speakeridfk: null }] };

  return (dispatch) => {
    if (selectedUsersStr != "") {
      var selectedUsers = JSON.parse(selectedUsersStr);
      //Update with speakerid to all the selected appuser
      var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser`;
      var update = [];
      _.map(selectedUsers, (item) => {
        update.push({
          appuserid: item.appuserid,
          eventid: session.eventid,
          speakeridfk: speakerid,
        });
      });
      var body = { resource: update };

      var successCallback = (data) => {
        // dispatch(fetchSpeakers(session));
        var returnData = { error: 0, data: data };
        callback(returnData);
      };

      var errorCallback = (error) => {
        var returnData = { error: 1, data: error };
        callback(returnData);
      };

      if (speaker.speakerid) {
        patchRequest(
          urlClear,
          bodyNull,
          session,
          dispatch,
          (data) => {
            patchRequest(
              url,
              body,
              session,
              dispatch,
              successCallback,
              errorCallback
            );
          },
          (error) => {
            callback({ error: 1, data: error });
          }
        );
      } else {
        patchRequest(
          url,
          body,
          session,
          dispatch,
          successCallback,
          errorCallback
        );
      }
    } else {
      if (speaker.speakerid) {
        patchRequest(
          urlClear,
          bodyNull,
          session,
          dispatch,
          (data) => {
            // dispatch(fetchSpeakers(session));
            var returnData = { error: 0 };
            callback(returnData);
          },
          (error) => {
            callback({ error: 1, data: error });
          }
        );
      } else {
        // dispatch(fetchSpeakers(session));
        var returnData = { error: 0, speakerid: speakerid };
        if (values.profileimage && values.profileimage !== "") {
          returnData.profileimage = values.profileimage;
        }
        callback(returnData);
      }
    }
  };
}

export function createSpeaker(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/speaker`;

  var speakerJson = {};
  speakerJson = { resource: values };

  return (dispatch) => {
    postRequest(
      url,
      speakerJson,
      session,
      dispatch,
      (data) => {
        var speakerid = data.resource[0].speakerid;
        callback({ success: 1, speakerid: speakerid });
      },
      (error) => {
        callback({ success: 0, data: error });
      }
    );
  };
}

export function openSpeakerModal(option) {
  return {
    type: OPEN_SPEAKER_MODAL,
    payload: option,
  };
}

export function updateSpeakerImage(image) {
  return {
    type: UPDATED_SPEAKER_IMAGE,
    payload: image,
  };
}

export function loadSpeakerData(speaker) {
  return {
    type: LOAD_EDIT_SPEAKER_DATA,
    payload: speaker,
  };
}
export function isEmpty(obj) {
  // null and undefined are "empty"
  if (obj == null) return true;
  // Assume if it has a length property with a non-zero value
  // that that property is correct.
  if (obj.length > 0) return false;
  if (obj.length === 0) return true;
  // If it isn't an object at this point
  // it is empty, but it can't be anything *but* empty
  // Is it empty?  Depends on your application.
  if (typeof obj !== "object") return true;
  // Otherwise, does it have any properties of its own?
  // Note that this doesn't handle
  // toString and valueOf enumeration bugs in IE < 9
  for (var key in obj) {
    if (hasOwnProperty.call(obj, key)) return false;
  }
  return true;
}

export function updateSpeakersFiles(file) {
  return (dispatch) => {
    dispatch({ type: UPDATE_SPEAKERS_FILES, payload: file });
  };
}

export function filesChanged(bool) {
  return (dispatch) => {
    dispatch({ type: SPEAKER_FILES_CHANGED, payload: bool });
  };
}

export function openImportSpeakerModal(showModal) {
  return { type: IMPORT_SPEAKER_MODAL, payload: showModal };
}

export function importSpeakers(session, values, duplicateData, callback) {
  let eventid = session.eventid;
  var url = `${INSTANCE_URL}/api/v2/bulkuploadData`;
  var body = {
    speakerlist: values,
    eventid: eventid,
    duplicateData: duplicateData,
    source: "speaker",
  };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // dispatch(fetchSpeakers(session));
        if (response.count > 0) {
          callback({ success: 1, count: response.count });
        } else {
          callback({ success: 2 });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function fetchDownloadSpeakerInfo(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/downloadspeakerinfo`;
  var body = { eventid: session.eventid };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (data) => {
        callback({ success: 1, data: data.result, count: data.count });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function getSpeakerCounts(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  var postData = {
    eventid: session.eventid,
    type: "speakerscount",
  };

  return (dispatch) => {
    postRequest(
      url,
      postData,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: SPEAKER_COUNTING_NUMBERS,
          payload: data,
        });
        callback({ success: 1, result: data });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function deleteAllSpeakers(session, callback) {
  var filter = encodeURI(`filter=(eventid=${session.eventid})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/speaker?${filter}`;

  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({ error: 0, data: data });
      },
      (error) => {
        callback({ error: 1, data: error });
      }
    );
  };
}

export function deleteBulkSpeakers(session, appUser, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/speaker`;
  var body = {
    resource: appUser,
  };

  return (dispatch) => {
    deleteBulkRequest(
      url,
      session,
      body,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}
